import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { SiteConfigManager } from '@atlas/core';
import { Label } from '@atlas/ui';

import StaticBlock from 'common/StaticBlock/StaticBlock';
import { isLocalEnv } from 'src/common/utils';

import AnjouanLicense from './AnjouanLicense';
import ApgLicense from './ApgLicense';
import GCLicense from './GCLicence';
import ReclameAquiLicense from './ReclameAquiLicense';
import XcmLicense from './XcmLicense';

const License = ({ EGamingIconSize = 75, hasTitle = true }) => {
  const enableApg = SiteConfigManager.getConfig('config.config.license.enableApg', false);
  const enableXcm = SiteConfigManager.getConfig('config.config.license.enableXcm', false);
  const enableGC = SiteConfigManager.getConfig('config.config.license.enableGC', false);
  const enableAnjouan = SiteConfigManager.getConfig('config.config.license.enableAnjouan', false);
  const customSettings = SiteConfigManager.getConfig('config.config.custom');

  const isMainSite = window.SYS_CONFIG.isMain;
  const footerType = customSettings?.footer_type;

  const isDefaultFooter = footerType === 'default';
  const isHiddenLicense = (!isMainSite && !isDefaultFooter) || footerType === 'without_license';

  const eGamingIconStyle = useMemo(
    () => ({
      minWidth: EGamingIconSize,
    }),
    [],
  );

  if (!isLocalEnv && !isHiddenLicense) {
    return (
      <div className="e-gaming-container">
        {hasTitle && <Label className="block-title" message="footer_title_license" />}
        <div className="e-gaming-block">
          {enableXcm && <XcmLicense iconSize={EGamingIconSize} iconStyle={eGamingIconStyle} />}
          {enableApg && <ApgLicense iconSize={EGamingIconSize} iconStyle={eGamingIconStyle} />}
          {enableGC && <GCLicense />}
          {enableAnjouan && (
            <AnjouanLicense
              iconSize={EGamingIconSize}
              iconStyle={{ ...eGamingIconStyle, maxWidth: eGamingIconStyle.minWidth }}
            />
          )}
          <ReclameAquiLicense />
        </div>

        <div className="e-gaming-text">
          <StaticBlock options={{ source: 'footer-license' }} />
        </div>
      </div>
    );
  }
};

License.propTypes = {
  EGamingIconSize: PropTypes.number,
  hasTitle: PropTypes.bool,
};

export default License;
